/** Other — document knowledge definition for custom documents. Pure data. */
export default {
  id: 'other',
  name: 'Other',
  description: 'A free-form document for anything the named types don’t cover.',
  purpose: 'Custom Design',
  recommendedSizes: [
    { name: 'Square', width: 1080, height: 1080, unit: 'px' },
    { name: 'A4', width: 2480, height: 3508, unit: 'px' },
  ],
  supportedOrientations: ['portrait', 'landscape', 'square'],
  supportsMultiplePages: true,
  supportsBleed: true,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: true,
  supportsTables: true,
  supportsPricing: true,
  supportsCTA: true,
  supportsOffers: true,
  supportsTimeline: true,
  supportsGallery: true,
  typicalSections: ['Header', 'Body', 'Footer'],
};
